export default {
  getUserId: (state) => state.userInfo.id || 0,
  getUserApplyStatus: (state) => state.userInfo.apply_status || 0
}
